export default __webpack_public_path__ + "static/media/logoconecttec.e8007441.svg";